export const crmKeys = {
    crm: (subdomain, options) => options ? ['crm', subdomain, options] : ['crm', subdomain],
    view: (subdomain) => ['crm-view', subdomain],
};
